import React from 'react';
import VideoPlayer from '../../../../../Components/WebChat/Conversation/VideoPlayer';
import { millisToMinutesAndSeconds } from '../../../../../Helpers/Utility';
import { AudioFile, AudioRecord } from '../../../../../assets/images';
import { useMediaProgress } from '../../../../utils';
import PropTypes from 'prop-types';

function AudioPreview({ media, channelId, isActive, videoControls }) {
   const { content, messageId } = media;
   const { media: mediaData = {} } = content || {};
   const { webHeight, audioType, duration, local_path, is_uploading, is_downloaded } = mediaData;
   const { downloadMedia } = useMediaProgress({
      channelId,
      is_uploading,
      is_downloaded,
      messageId,
      autoDownload: true,
      fileSave: false,
      local_path,
   });

   React.useEffect(() => {
      if (!local_path && isActive) {
         downloadMedia();
      }
   }, [local_path, isActive]);

   return (
      <div className="video-wrapper1" data-duration={millisToMinutesAndSeconds(duration)}>
         {local_path ? (
            <VideoPlayer
               {...videoControls(local_path, messageId, '', isActive)}
               fileType={'audio'}
               //    handlePlay={handlePlayPause}
               audioDuration={millisToMinutesAndSeconds(duration)}
               audioType={audioType}
               palyStatus={true}
            />
         ) : (
            <>
               <img
                  src={audioType !== 'recording' ? AudioFile : AudioRecord}
                  alt={audioType !== 'recording' ? AudioFile : AudioRecord}
                  style={{ height: webHeight, width: 'auto' }}
                  className="previewVideoThumbnail"
               />
               <div style={{ zIndex: 3 }}>
                  <div className="spiner" style={{ display: 'flex', alignItems: 'center' }}>
                     <div className="spin"></div>
                  </div>
               </div>
            </>
         )}
      </div>
   );
}

AudioPreview.propTypes = {
   media: PropTypes.shape({
      content: PropTypes.shape({ media: PropTypes.object }),
      messageId: PropTypes.string,
   }),
   channelId: PropTypes.string.isRequired,
   isActive: PropTypes.bool.isRequired,
   videoControls: PropTypes.object,
};

export default AudioPreview;
